import { StorageSerializers, useSessionStorage } from '@vueuse/core'

const TTL = 10 * 60000

export const useCacheStorage = () => {
  const now = Date.now()

  const getCache = (key: string) => {
    const storage = useSessionStorage(
      key,
      { ttl: now, data: null },
      {
        serializer: StorageSerializers.object
      }
    )

    if (storage.value.ttl + TTL < now) {
      storage.value.data = null
      storage.value.ttl = now
    }

    return storage
  }

  const getCacheBoolean = (key: string) => {
    return useSessionStorage(key, null, {
      serializer: StorageSerializers.boolean
    })
  }

  const setCache = (key: string, value: any) => {
    const cache = getCache(key)
    cache.value = value
  }

  return { getCache, getCacheBoolean, setCache }
}
